import React from 'react';
import { FormDialog } from 'dialog';
import { getTempId } from 'utils';
import { PlusIcon } from 'components/icons';
import { FormOnSubmit } from 'components/form';
import { EditJobsiteFormFormData } from 'containers/jobsiteConfiguration/types';
import { getDefaultValues, getFormInputsHook } from './JobsiteFormModal.forms';
import { AddJobsiteFormModalProps } from './types';

export function AddJobsiteFormModal(
  props: AddJobsiteFormModalProps,
): React.ReactElement {
  const { isOpen, onCancel, onConfirm, jobsiteForms, formsOptions } = props;
  const [isFormDirty, setIsFormDirty] = React.useState(false);

  const onSubmit: FormOnSubmit<EditJobsiteFormFormData> = (data): void => {
    onConfirm?.({ id: getTempId(), ...data });
  };

  const formInputs = React.useMemo(
    () => getFormInputsHook({ jobsiteForms, formsOptions }),
    [jobsiteForms, formsOptions],
  );
  const defaultValues = React.useMemo(() => getDefaultValues(), []);

  return (
    <FormDialog
      id="addJobsiteForm"
      open={isOpen}
      setOpen={onCancel}
      onIsDirtyChange={setIsFormDirty}
      title="Add Log"
      variant="drawer"
      inputs={formInputs}
      onSubmit={onSubmit}
      defaultValues={defaultValues}
      inputsContainerClassName="odin-grid odin-grid-cols-6 odin-gap-6"
      actionText="Add Log"
      actionIcon={PlusIcon}
      actionButtonEnabled={isFormDirty}
    />
  );
}
